<template lang="pug">
  div
    el-row.labelStyle
      el-col(:span="12")
        app-display(
          label="VTN:",
          :content="dadosJson.avaliacaoImovel.vtn || '-'"
        )
        app-display(
          label="Valor das Benfeitorias Reprodutivas:",
          :content="dadosJson.avaliacaoImovel.valorBenfeitoriasReprodutivas || '-'"
        )
        app-display(
          label="Valor das Benfeitorias Não Reprodutivas:",
          :content="dadosJson.avaliacaoImovel.valorBenfeitoriasNaoReprodutivas || '-'"
        )
      el-col(:span="12")
        app-display(
          label="Intimação de Valores:",
          :content="dadosJson.avaliacaoImovel.intimacaoValores || '-'"
        )
        app-display(
          label="Contrapropostas:",
          :content="dadosJson.avaliacaoImovel.contraPropostas || '-'"
        )
        app-display(
          label="CAU/ART:",
          :content="dadosJson.avaliacaoImovel.cauArt || '-'"
        )
    listagem-documentos(
      v-if="dadosJson.avaliacaoImovel.documentosLaudo"
      :documentos="dadosJson.avaliacaoImovel.documentosLaudo",
      :protocoloCadastroOriginal="dadosJson.protocolo"
      ownerDocumento="AVALIACAO_IMOVEL_LAUDO"
      :compararDocumentos="null"
      :versaoCadastro = "null"
    )
    el-row.labelStyle.mt-30px
      el-col(:span="12")
        app-display(
          label="Nome do Responsável:",
          :content="dadosJson.georreferenciamento.responsavel.nome || '-'"
        )
      el-col(:span="12")
        app-display(
          label="Matrícula do Responsável:",
          :content="dadosJson.georreferenciamento.responsavel.matricula || '-'"
        )
    listagem-documentos(
      v-if="dadosJson.georreferenciamento.documentos"
      :documentos="dadosJson.georreferenciamento.documentos",
      :protocoloCadastroOriginal="dadosJson.protocolo"
      ownerDocumento="GEORREFERENCIAMENTO"
      :compararDocumentos="null"
      :versaoCadastro = "null"
    )
</template>

<script>
import AppDivider from '../AppDivider'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import ListagemDocumentos from '../informacoesCadastro/ListagemDocumentos'

export default {
  props: {
    dadosJson: {
      type: Object,
      required: false
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppDisplayMultiple,
    ListagemDocumentos
  },

  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => {
        if (telefone?.numero) {
          return telefone.numero + (telefone.identificacao ? ` - ${telefone.identificacao}` : '')
        } else {
          return telefone
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
    margin-top: 10px;
}

.mt-30px {
  margin-top: 30px;
}

>>>.text .text {
    color: #ff0000 !important;
}

@media (max-width: 780px) {
    .labelStyle {
        display: flex;
        flex-direction: column;
        width: 395px;
    }

    .margin-top {
        display: flex;
        flex-direction: column;
        width: 490px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/AvaliacaoRf.vue